export default class TextInputQuizAnswer {
  constructor(public readonly text: string) {}
}
